export const convertLetterSpacingToRem = (
  letterSpacingInPx: number,
  fontSizeInPx: number
): number => letterSpacingInPx / fontSizeInPx;
